import React, { useCallback } from 'react';
import { Input } from 'antd';
import style from './style.module.scss';
import { ToggleableSection } from '../../../../components/form-fields/toggleable-section';
import { LabeledField } from '../../../../components/form-fields/labeled-field';

interface ABTestingSectionProps {
    inTestingCampaign?: boolean;
    originalPrice: number;
    rebateAmount: number;
    setFieldValue: (field: string, value: unknown) => void;
}

interface PriceFieldProps {
    label: string;
    tooltip: string;
    value: string | number;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

function PriceField({ label, tooltip, value, onChange }: PriceFieldProps) {
    return (
        <LabeledField label={label} helperText={tooltip}>
            <Input
                type="number"
                prefix="$"
                value={value || ''}
                onChange={onChange}
                addonAfter="$"
            />
        </LabeledField>
    );
}

export const ABTestingSection = ({
    inTestingCampaign,
    originalPrice,
    rebateAmount,
    setFieldValue,
}: ABTestingSectionProps) => {
    const handleSwitchChange = useCallback(
        (checked: boolean) => setFieldValue('inTestingCampaign', checked),
        [setFieldValue]
    );

    const handleInputChange = (
        field: 'originalPrice' | 'rebateAmount',
        value: string
    ) => {
        const numericValue = parseFloat(value);
        setFieldValue(field, isNaN(numericValue) ? 0 : numericValue);
    };

    return (
        <ToggleableSection
            title="AB Testing"
            checked={inTestingCampaign ?? false}
            onToggleChange={handleSwitchChange}
        >
            <div className={style.input_row}>
                <PriceField
                    label="Original Price"
                    tooltip="Item's pre-promotion cost."
                    value={originalPrice || ''}
                    onChange={(e) =>
                        handleInputChange('originalPrice', e.target.value)
                    }
                />
                <PriceField
                    label="Rebate Amount"
                    tooltip="Price the customer will pay after discount."
                    value={rebateAmount || ''}
                    onChange={(e) =>
                        handleInputChange('rebateAmount', e.target.value)
                    }
                />
            </div>
        </ToggleableSection>
    );
};
